module.exports = __webpack_public_path__ + "d5e449d9acb88d933c54d0173e615cc8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/regeneron_pharmaceuticals_2023_chart.png
// module id = 1731
// module chunks = 0